import { Link } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';

// project imports

import AuthCardWrapper from '../AuthCardWrapper';
import AuthLogin from './auth-forms/AuthLogin';
import { alpha } from '@mui/material/styles';

// assets

// ================================|| AUTH3 - LOGIN ||================================ //

const Login = ({ forceOpen }: { forceOpen: Function }) => {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Grid
            container
            direction="column"
            justifyContent="flex-end"
            sx={{
                backgroundColor: '#050505'
                // borderColor: theme.palette.secondary.main,
                // border:'1px solid',
            }}
        >
            <Grid item xs={12} className="">
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item sx={{ padding: '0px' }}>
                        <AuthCardWrapper>
                            <Grid
                                container
                                spacing={0}
                                alignItems="center"
                                justifyContent="center"
                                sx={{ backgroundColor: '#050505', margin: '0px' }}
                            >
                                <Grid item xs={12}>
                                    <Grid
                                        container
                                        direction={matchDownSM ? 'column-reverse' : 'row'}
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Grid item>
                                            <Stack alignItems="center" justifyContent="center" spacing={1}>
                                                <Typography
                                                    // color={theme.palette.secondary.main}
                                                    gutterBottom
                                                    variant={matchDownSM ? 'h3' : 'h1'}
                                                    sx={{
                                                        // color: '#212121',
                                                        color: theme.palette.secondary.main,
                                                        // marginBottom: '1.5625rem !important',
                                                        textTransform: 'uppercase',
                                                        fontSize: '1.25rem',
                                                        fontWeight: '700',
                                                        lineHeight: '1.5625rem ',
                                                        marginBottom: '25px !important'
                                                    }}
                                                >
                                                    Login
                                                </Typography>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <AuthLogin />
                                </Grid>

                                {/* <Grid item xs={12}>
                                    <Grid item container direction="column" alignItems="center" xs={12}>
                                        <Button
                                            onClick={() => forceOpen('forgot')}
                                            sx={{
                                                background: 'none',
                                                color: theme.palette.secondary.main,
                                                fontSize: '0.875rem',
                                                fontWeight: '700',
                                                ':hover': {
                                                    background: 'none'
                                                }
                                            }}
                                        >
                                            Forgot Password?
                                        </Button>
                                    </Grid>
                                </Grid> */}
                                <Grid item xs={12} sx={{ padding: '15px 0px 15px 0px' }}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid item container direction="column" alignItems="center" xs={12}>
                                        <Button
                                            onClick={() => forceOpen('register')}
                                            sx={{
                                                background: 'none',
                                                color: theme.palette.secondary.main,
                                                fontSize: '0.875rem',
                                                fontWeight: '700',
                                                borderColor: theme.palette.secondary.main,
                                                border: '1px solid',
                                                width: '100%',
                                                marginTop: '10px',
                                                marginBottom: '10px',
                                                textTransform: 'none',
                                                ':hover': {
                                                    background: 'none'
                                                }
                                            }}
                                        >
                                            Don&apos;t have an account?
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </AuthCardWrapper>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Login;
